"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgYouTubeLogo = function SvgYouTubeLogo(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#youTube-logo_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.885 14.433a7.037 7.037 0 0 0-4.951-4.983c-4.378-1.177-21.878-1.177-21.878-1.177s-17.5 0-21.879 1.177a7.038 7.038 0 0 0-4.95 4.983C.055 18.83.055 28 .055 28s0 9.17 1.17 13.567a7.038 7.038 0 0 0 4.951 4.983c4.379 1.177 21.878 1.177 21.878 1.177s17.5 0 21.879-1.177a7.04 7.04 0 0 0 4.95-4.983C56.057 37.17 56.057 28 56.057 28s0-9.17-1.171-13.567Z",
    fill: "#FF0302"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.328 36.327V19.673L36.965 28l-14.637 8.327Z",
    fill: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "youTube-logo_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h56v56H0z"
  }))));
};

var Memo = /*#__PURE__*/(0, React.memo)(SvgYouTubeLogo);
var _default = Memo;
exports["default"] = _default;